import { Controller } from "@hotwired/stimulus";
import tippy from "tippy.js";

export default class extends Controller {
  static targets = ["input", "options", "itemsList"];

  tippyInstance;

  inputName;

  initialize() {
    const element = this.element;

    this.inputName = this.inputTarget.name;
    this.inputTarget.name = "";

    if (!this.inputTarget.readOnly || this.inputTarget.disabled) {
      this.tippyInstance = tippy(this.inputTarget, {
        theme: "light-border",
        offset: [0, 8],
        maxWidth: "none",
        arrow: false,
        placement: "bottom-start",
        trigger: "click",
        interactive: true,
        allowHTML: true,
        animation: "shift-toward-extreme",
        content: () => this.optionsTarget.outerHTML,
        appendTo() {
          return element;
        }
      });
    }
  }

  selectOption({ target: item }) {
    if (this.inputTarget.readOnly || this.inputTarget.disabled) return;
    item.classList.add("hidden");
    const innerHTML = this.itemsListTarget.dataset.template
      .replaceAll("##ID##", item.dataset.value)
      .replaceAll("##NAME##", item.innerHTML);

    const tmpItem = document.createElement("div");
    tmpItem.innerHTML = innerHTML;

    this.itemsListTarget.append(tmpItem.children[0]);
  }

  unselectOption(e) {
    if (this.inputTarget.readOnly || this.inputTarget.disabled) return;
    e.stopPropagation();
    const { target: button } = e;
    const listItem = button.closest(".badge");
    listItem.remove();
    this.tippyInstance.popper
      .querySelector(`[data-value="${listItem.dataset.value}"]`)
      .classList.remove("hidden");
  }
}
